import React from 'react';
import PropTypes from 'prop-types';
import '../Public/css/CustomButton.scss';

const CustomButton = ({ onClick, children, className, onMouseLeave, onMouseEnter, height, width, disabled, dataTip, place, type }) => {
    return (
        <>
            <button
                className={`custom-button ${className}`}
                onClick={onClick}
                onMouseLeave={onMouseLeave}
                onMouseEnter={onMouseEnter}
                disabled={disabled}
                type={type}
            >
                {children}
            </button>
        </>
    );
};

CustomButton.propTypes = {
    onClick: PropTypes.func,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
    disabled: PropTypes.bool
};

CustomButton.defaultProps = {
    className: "",
    height: "",
    width: "",
    disabled: false,
    dataTip: "",
    place: "bottom",
    type: 'button',
}

export default CustomButton;
